import gql from 'graphql-tag'

export const UPDATE_USER = gql`
  mutation UpdateUser($userUuid: String, $user: UpdateUserInput) {
    updateUser(userUuid: $userUuid, user: $user) {
      name
      uuid
      id
      email
      phoneNumber
      firstName
      lastName
      location {
        city
        country
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations/UpdateUser.tsx